import Vue from 'vue'
import Popper from 'popper.js'
import TPopperButton from './popper-button.vue'

class Ctor {
  constructor () {
    this.popperEl = null
    this.popperJS = null
    this.VM = null
    this.onPopperConfirm = null
    this.onPopperCancel = null
    this.el = null
    this.onPopperShow = null
    this.onPopperHide = null
    let that = this
    this.PopperVM = Vue.extend({
      components: { TPopperButton },
      data () {
        return {
          visible: '',
          width: '',
          prefixCls: '',
          title: '',
          confirm: '',
          localeCancelText: '',
          localeOkText: '',
          showTitle: '',
          content: ''
        }
      },
      computed: {
        styles () {
          let style = {}
          if (this.width) {
            style.width = `${this.width}px`
          }
          return style
        }
      },
      methods: {
        stopClick () {
          return false
        },
        onPopperConfirm () {
          this.visible = false
          that.setVisibleInPopper(0)
          that.onPopperConfirm && that.onPopperConfirm()
        },
        onPopperCancel () {
          this.visible = false
          that.setVisibleInPopper(0)
          that.onPopperCancel && that.onPopperCancel()
        }
      },
      template: `
        <transition name="fade">
          <div v-show="visible" ref="popper" :class="['popover']" :style="styles" @click.stop="stopClick">
            <div :class="[prefixCls + '-arrow']"></div>
            <div :class="[prefixCls + '-content']">
              <h3 v-if="confirm&&title" :class="[prefixCls + '-title']" v-html="title"></h3>
              <div v-if="confirm" :class="[prefixCls + '-inner']">
                <div :class="[prefixCls + '-footer','text-right']">
                  <t-popper-button :locale-cancel-text="localeCancelText" :locale-ok-text="localeOkText" @on-popper-cancel="onPopperCancel" @on-popper-confirm="onPopperConfirm"></t-popper-button>
                </div>
                </div>
                <div v-if="!confirm" :class="[prefixCls + '-inner']">
                  <div v-if="showTitle" ref="title" :class="[prefixCls + '-title']">
                    <slot name="title">
                      <div :class="[prefixCls + '-title-inner']">{{ title }}</div>
                    </slot>
                  </div>
                  <div :class="[prefixCls + '-body']">
                    <div :class="[prefixCls + '-body-content']">
                      <slot name="content">
                        <div :class="[prefixCls + '-body-content-inner']">{{ content }}</div>
                      </slot>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </transition>
      `
    })
  }

  setVisibleInPopper (visible) {
    let el = this.el
    let options = {
      visible: !!parseInt(visible)
    }
    Object.keys(options).map(key => {
      if (key !== 'onPopperShow' && key !== 'onPopperHide' && key !== 'onPopperConfirm' && key !== 'onPopperCancel') {
        switch (Object.prototype.toString.call(options[key])) {
          case '[object String]':
          case '[object Number]':
            el.dataset[key] = options[key]
            break
          case '[object Boolean]':
            el.dataset[key] = options[key] ? 1 : 0
            break
          default:
            el.dataset[key] = options[key] ? options[key] : 0
            break
        }
      }
    })
    if (options.visible) {
      this.onPopperShow && this.onPopperShow()
    } else {
      this.onPopperHide && this.onPopperHide()
    }
  }

  setVisible (e, opts, binding, el, flag) {
    let ops = e.currentTarget.dataset
    if (e.type === 'click') {
      ops.visible = ops.visible === '1' ? 0 : 1
    } else {
      ops.visible = flag
    }
    let options = {
      visible: !!parseInt(ops.visible),
      width: ops.width,
      prefixCls: ops.prefixCls,
      title: ops.title,
      confirm: !!parseInt(ops.confirm),
      localeCancelText: ops.localeCancelText,
      localeOkText: ops.localeOkText,
      showTitle: !!ops.title,
      content: ops.content,
      placement: ops.placement
    }
    Object.keys(options).map(key => {
      if (this.VM) {
        this.VM.$set(this.VM.$data, key, options[key])
      }
      if (
        key !== 'onPopperShow' &&
        key !== 'onPopperHide' &&
        key !== 'onPopperConfirm' &&
        key !== 'onPopperCancel'
      ) {
        switch (Object.prototype.toString.call(options[key])) {
          case '[object String]':
          case '[object Number]':
            el.dataset[key] = options[key]
            break
          case '[object Boolean]':
            el.dataset[key] = options[key] ? 1 : 0
            break
          default:
            el.dataset[key] = options[key] ? options[key] : 0
            break
        }
      }
    })
    /**
     * 做异步处理，以便处理dom没有生成的情况
     */
    setTimeout(() => {
      this.popperJS
        ? this.popperJS.update()
        : this.createPopper(
          ops,
          options,
          {
            gpuAcceleration: false,
            boundariesElement: 'viewport',
            forceAbsolute: true
          },
          el
        )
    }, 0)
    if (options.visible) {
      binding.value.onPopperShow && binding.value.onPopperShow()
    } else {
      binding.value.onPopperHide && binding.value.onPopperHide()
    }
  }

  createPopper (options, binding, popperOpt, el) {
    let PopperVM = this.PopperVM
    this.VM = new PopperVM({
      data: {
        visible: !!parseInt(options.visible),
        width: options.width,
        prefixCls: options.prefixCls,
        title: options.title,
        confirm: !!parseInt(options.confirm),
        localeCancelText: options.localeCancelText,
        localeOkText: options.localeOkText,
        showTitle: !!options.title,
        content: options.content,
        placement: options.placement
      }
    })
    options = {
      visible: !!parseInt(options.visible),
      width: options.width,
      prefixCls: options.prefixCls,
      title: options.title,
      confirm: !!parseInt(options.confirm),
      localeCancelText: options.localeCancelText,
      localeOkText: options.localeOkText,
      showTitle: !!options.title,
      content: options.content,
      placement: options.placement
    }
    Object.assign(options, binding.value)
    Object.keys(options).map(key => {
      if (
        key !== 'onPopperShow' &&
        key !== 'onPopperHide' &&
        key !== 'onPopperConfirm' &&
        key !== 'onPopperCancel'
      ) {
        switch (Object.prototype.toString.call(options[key])) {
          case '[object String]':
          case '[object Number]':
            el.dataset[key] = options[key]
            break
          case '[object Boolean]':
            el.dataset[key] = options[key] ? 1 : 0
            break
          default:
            el.dataset[key] = options[key] ? options[key] : 0
            break
        }
      }
    })

    const popper = (this.popperEl =
      this.VM && this.VM.$mount().$el ? this.VM.$mount().$el : '')
    const reference = el
    if (!popper || !reference) return
    if (this.popperJS && this.popperJS.hasOwnProperty('destroy')) {
      this.popperJS.destroy()
    }
    document.body.appendChild(popper)
    const isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1
    const boundariesElement = isIE10 === true ? 'body' : 'viewport'
    popperOpt.placement = options.placement
    popperOpt.modifiers = {
      preventOverflow: {
        boundariesElement: boundariesElement
      },
      computeStyle: {
        gpuAcceleration: false
      }
    }
    this.popperJS = new Popper(reference, popper, popperOpt)
  }
  destoryPopper () {
    const popper = this.popperEl
    if (this.popperJS && popper) {
      if (popper.parentNode) {
        popper.parentNode.removeChild(popper)
      } else {
        this.popperJS.popper.parentNode.removeChild(this.popperJS.popper)
      }
      this.popperJS.destroy()
      this.popperJS = null
    }
  }
  updatePopperOps (el, binding) {
    let ops = el.dataset
    ops.visible = 0
    let options = {
      visible: !!parseInt(ops.visible),
      width: ops.width,
      prefixCls: ops.prefixCls,
      title: ops.title,
      confirm: !!parseInt(ops.confirm),
      localeCancelText: ops.localeCancelText,
      localeOkText: ops.localeOkText,
      showTitle: !!ops.title,
      content: ops.content,
      placement: ops.placement
    }
    Object.assign(options, binding.value)
    Object.keys(options).map(key => {
      if (
        key !== 'onPopperShow' &&
        key !== 'onPopperHide' &&
        key !== 'onPopperConfirm' &&
        key !== 'onPopperCancel'
      ) {
        switch (Object.prototype.toString.call(options[key])) {
          case '[object String]':
          case '[object Number]':
            el.dataset[key] = options[key]
            break
          case '[object Boolean]':
            el.dataset[key] = options[key] ? 1 : 0
            break
          default:
            el.dataset[key] = options[key] ? options[key] : 0
            break
        }
      }
    })
  }

  clickOutSide (el, popper, cb) {
    function documentHandler (e) {
      if (el.contains(e.target) || popper.contains(e.target)) {
        return false
      }
      cb && cb(e)
    }
    document.addEventListener('click', documentHandler, false)
  }
  setCickOutSide (el, binding) {
    let ops = el.dataset
    let options = {
      visible: !!parseInt(ops.visible),
      width: ops.width,
      prefixCls: ops.prefixCls,
      title: ops.title,
      confirm: !!parseInt(ops.confirm),
      localeCancelText: ops.localeCancelText,
      localeOkText: ops.localeOkText,
      showTitle: !!ops.title,
      content: ops.content,
      placement: ops.placement
    }
    Object.keys(options).map(key => {
      if (this.VM) {
        this.VM.$set(this.VM.$data, key, options[key])
      }
      if (
        key !== 'onPopperShow' &&
        key !== 'onPopperHide' &&
        key !== 'onPopperConfirm' &&
        key !== 'onPopperCancel'
      ) {
        switch (Object.prototype.toString.call(options[key])) {
          case '[object String]':
          case '[object Number]':
            el.dataset[key] = options[key]
            break
          case '[object Boolean]':
            el.dataset[key] = options[key] ? 1 : 0
            break
          default:
            el.dataset[key] = options[key] ? options[key] : 0
            break
        }
      }
    })
    // this.popperJS ? this.popperJS.update() : this.createPopper(ops, options, {
    //   gpuAcceleration: false,
    //   boundariesElement: 'viewport',
    //   forceAbsolute: true
    // }, el)
  }
}

export default Ctor



// WEBPACK FOOTER //
// ./src/components/poptip/ctor.js